// app/i18n.ts
import { createInstance, Resource, i18n as I18nType } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { defaultLocale } from '~/utils/language';

export type I18nResources = Record<string, Record<string, string>>;

export function initClientI18nSync(locale: string, resources: I18nResources): I18nType {
  const i18n = createInstance().use(initReactI18next);

  i18n.init({
    lng: locale,
    fallbackLng: defaultLocale,
    ns: ['translation'],
    defaultNS: 'translation',
    resources: {
      [locale]: resources,
    } as Resource,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

  return i18n;
}
